import React, { useEffect } from 'react';
import {
	Navigate,
	Route,
	Routes,
	useNavigate,
	useParams,
} from 'react-router-dom';
import {
	PolicyContext,
	PolicyData,
	withPolicyContext,
} from '../../../context/policy';
import AuxDataView from '../../auxData/AuxDataView';
import LargeCenterSpinner from '../../LargeCenterSpinner';
import ProtectedRoute from '../../ProtectedRoute';
import ExposureDetails from '../Exposures/ExposureDetails';
import PerilDetails from '../Perils/PerilDetails';
import Perils from '../Perils/Perils';

interface Props {
	policyData: PolicyData;
}

// Route: '.../exposures/:exposureId'
const ExposureRoutes = (props: Props) => {
	const { policyData } = props;
	const { selectedQuote, policy, setSelectedExposure, selectedExposure } =
		policyData;
	const params = useParams();
	const navigate = useNavigate();
	const { exposureId } = params;
	const isAdded = exposureId.split('-')[0] === 'added';
	const exposureName = exposureId.split('-')[1];

	const addedExposure = isAdded && {
		locator: exposureId,
		name: exposureName,
		displayId: exposureId,
		characteristics: [] as any,
		perils: [] as any,
		policyholderLocator: '',
		productLocator: '',
		policyLocator: '',
		createdTimestamp: '',
		updatedTimestamp: '',
	};

	useEffect(() => {
		let newExposure;
		if (selectedQuote && !policy.issuedTimestamp) {
			newExposure = isAdded
				? addedExposure
				: selectedQuote.exposures.find(
						(exposure) => exposure.displayId === exposureId,
				  );
		} else {
			newExposure = isAdded
				? addedExposure
				: policy.exposures.find(
						(exposure) => exposure.displayId === exposureId,
				  );
		}

		setSelectedExposure(newExposure);

		return () => {
			setSelectedExposure(null);
		};
	}, [exposureId, selectedQuote?.exposures, policy?.exposures]);

	if (!selectedExposure) {
		return <LargeCenterSpinner />;
	}

	return (
		<PolicyContext.Provider value={policyData}>
			<Routes>
				<Route
					path='auxData'
					element={
						<ProtectedRoute permission='auxData.fetch'>
							<AuxDataView
								navigate={navigate}
								entityLocator={exposureId}
								entityType='exposure'
							/>
						</ProtectedRoute>
					}
				/>
				<Route path='perils'>
					<Route index element={<Perils />} />
					<Route path=':perilId'>
						<Route index element={<PerilDetails />} />
						<Route
							path='auxData'
							element={
								<ProtectedRoute permission='auxData.fetch'>
									<AuxDataView
										navigate={navigate}
										entityPath='perilId'
										entityType='peril'
									/>
								</ProtectedRoute>
							}
						/>
					</Route>
				</Route>
				<Route path='' element={<ExposureDetails />} />
				<Route path='/' element={<Navigate to='' />} />
			</Routes>
		</PolicyContext.Provider>
	);
};

export default withPolicyContext<Props>(ExposureRoutes);
